const ACTIVE_SHIPPING_STATUSES = new Set([
  'requested',
  'searching',
  'assigned',
  'goingToOrigin',
  'arrivedAtOrigin',
  'inTransit',
  'cancellationRequested',
]);
const TERMINAL_SHIPPING_STATUSES = new Set([
  'concluded',
  'cancelled',
  'cancellationAccepted',
]);

export const hasActiveIfoodShippingForCustomerTracking = (order = {}) => {
  const shipping = order?.shipping && typeof order.shipping === 'object' ? order.shipping : null;
  if (!shipping) return false;

  const status = String(shipping.status || '').trim();
  const cancelStatus = String(shipping.cancelRequest?.status || '').trim();
  if (
    TERMINAL_SHIPPING_STATUSES.has(status) ||
    TERMINAL_SHIPPING_STATUSES.has(cancelStatus) ||
    (shipping.active === false && shipping.cancelRequest?.ok === true)
  ) {
    return false;
  }

  const request = shipping.request && typeof shipping.request === 'object' ? shipping.request : {};
  const tracking = shipping.tracking && typeof shipping.tracking === 'object' ? shipping.tracking : {};
  return Boolean(
    shipping.active === true ||
    ACTIVE_SHIPPING_STATUSES.has(status) ||
    request.accepted ||
    request.ok ||
    request.requestedAt ||
    request.idempotencyKey ||
    request.response ||
    tracking.data ||
    tracking.checkedAt
  );
};
